/**
 * Queue list scroll lives on `.extractpdf-cardcontent` (overflow:auto),
 * not on window. Persist/restore that container so return-from-invoice
 * lands where the operator left off.
 */
const CONTAINER_SELECTOR = ".extractpdf-cardcontent";
const STORAGE_KEY = "queueScrollTop";

export const getQueueScrollTop = () => {
  const el = document.querySelector(CONTAINER_SELECTOR);
  if (el) return el.scrollTop;
  return window.scrollY || 0;
};

export const saveQueueScrollTop = (position = getQueueScrollTop()) => {
  const top = Number(position) || 0;
  try {
    sessionStorage.setItem(STORAGE_KEY, String(top));
  } catch (err) {
    // storage unavailable
  }
  return top;
};

export const consumeSavedQueueScrollTop = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (raw == null || raw === "") return null;
    const top = Number.parseInt(raw, 10);
    return Number.isFinite(top) ? top : null;
  } catch (err) {
    return null;
  }
};

export const restoreQueueScrollTop = (position) => {
  const top = Number.parseInt(position, 10);
  if (!Number.isFinite(top) || top < 0) return;

  const apply = () => {
    const el = document.querySelector(CONTAINER_SELECTOR);
    if (el) {
      el.scrollTop = top;
    } else {
      window.scrollTo(0, top);
    }
  };

  apply();
  requestAnimationFrame(() => {
    apply();
    requestAnimationFrame(apply);
  });
};
